export type Mailer = {
  sender: string
  config: {
    host: string
    port: number
    auth: {
      user: string
      pass: string
    }
  }
}

export type PurchaseRestrictions = {
  limits: {
    daily: number
    monthly: number
  },
  block: {
    server: boolean
    vpn: boolean
    robot: boolean
    proxy: boolean
    riskScore: number
    trxFailed: number
    trxPending: number
  },
  maxMsisdn: number
  maxDevices: number
  maxIsp: number

}

export type Settings = {
  mailer: Mailer
  purchaseRestrictions: PurchaseRestrictions
}

export const initialSettings : Settings= {
  mailer: {
    sender: '',
    config: {
      host: '',
      port: 0,
      auth: {
        user: '',
        pass: ''
      }
    }
  },
  purchaseRestrictions: {
    limits: {
      daily: 0,
      monthly: 0
    },
    block: {
      vpn: false,
      server: false,
      robot: false,
      proxy: false,
      riskScore: 0,
      trxFailed: 0,
      trxPending: 0
    },
    maxMsisdn: 0,
    maxDevices: 0,
    maxIsp: 0
  }
}
